/* export const rootUrl = "https://app.otimizetelemedicina.com.br/";
export const apiUrl = "https://app.otimizetelemedicina.com.br/api/"; */

export const rootUrl = "https://saude.nixs.com.br/admin/";
export const apiUrl = "https://saude.nixs.com.br/admin/api/";

export const SCROLL = 200;
export const firebaseKey =
  "AAAAKLIoqro:APA91bHWBhF3pQzcqJfkHIyOYSB3oSA5CRzn3twH8YQ0490RjWl_i-kjKziw7iVTvoI4fj3Gvg2zMItChyNj0eKqi84mAlAL58QQQI0282hU7pRMg6t9tgOHzrxTl6mtz_Hmu1k2JAHA";
